import axios from "axios";

export function fetchFilters(params = {}) {
    return axios.get('/onsite-drycleaning/clsystem/api/v1/filters', {params: params})
}
